import {
	type ZodNullable,
	type ZodNumber,
	type ZodOptional,
	type ZodString,
	type ZodType,
	type ZodTypeAny,
	z,
	ZodError,
} from "zod";
import type { WithTranslation } from "react-i18next";

const messages = {
	minMaxPercentage: "Select a value between 0 and 100",
};
export const zExt = {
	percentage: (): ZodNumber =>
		z
			.number({ invalid_type_error: messages.minMaxPercentage })
			.min(0, { message: messages.minMaxPercentage })
			.max(100, { message: messages.minMaxPercentage }),
	maybe<T extends ZodType>(x: T): ZodNullable<ZodOptional<T>> {
		return x.optional().nullable();
	},
	nonEmptyString(t: WithTranslation["t"], minLength = 1): ZodString {
		return z
			.string({ required_error: t("REQUIRED_FIELD"), invalid_type_error: t("REQUIRED_FIELD") })
			.min(minLength, t("REQUIRED_FIELD"));
	},
	versioned<T extends ZodTypeAny>(maxVersion: number, dataShape: T) {
		return z.object({
			version: z.number().min(1).max(maxVersion),
			data: dataShape,
		});
	},
};

export type Versioned<T> = {
	/** Version number, from 1 onwards */
	version: number;
	data: T;
};

export function validateZodDefinition(validator: ZodTypeAny) {
	return (item: unknown, ctx: z.RefinementCtx) => {
		try {
			validator.parse(item);
		} catch (error) {
			if (error instanceof ZodError) {
				error.errors.forEach((e) => {
					ctx.addIssue({ path: e.path, message: e.message, code: "custom" });
				});
			}
		}
	};
}
